// extracted by mini-css-extract-plugin
module.exports = {"textos_html":"Capitulo1__textos_html__1C-qa","divImagen":"Capitulo1__divImagen__2smwV"};